import { z } from 'zod';
import { isoDate, uuid } from './common';

/** A connector this person let in, for the Connected apps card. */
export const connectedApp = z.object({
  id: uuid,
  name: z.string(),
  clientId: z.string(),
  scope: z.string(),
  lastUsedAt: isoDate.nullable(),
  createdAt: isoDate,
});
export type ConnectedApp = z.infer<typeof connectedApp>;

/** A personal token, without its secret — that is shown once, at creation. */
export const mcpToken = z.object({
  id: uuid,
  name: z.string(),
  prefix: z.string(),
  scopes: z.array(z.string()),
  createdAt: isoDate,
  lastUsedAt: isoDate.nullable(),
  expiresAt: isoDate.nullable(),
  revokedAt: isoDate.nullable(),
});
export type McpToken = z.infer<typeof mcpToken>;

export const createdMcpToken = mcpToken.extend({ token: z.string() });
export type CreatedMcpToken = z.infer<typeof createdMcpToken>;

export const createMcpTokenBody = z.object({
  name: z.string().trim().min(1).max(100),
  scopes: z.array(z.string()).min(1).optional(),
  expiresInDays: z.number().int().min(1).max(3650).nullable().optional(),
});
export type CreateMcpTokenBody = z.infer<typeof createMcpTokenBody>;
